import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "../Button/Button";

const DateFilter = ({ value, onChange, onOpen, onBlur, isOpen }) => {
  const dropdownRef = useRef(null);

  const dateOptions = [
    "Today",
    "Yesterday",
    "This week",
    "This month",
    // "This Year",
  ];

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        onBlur();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, onBlur]);

  const handleSelect = (option) => {
    onChange(option);
    onBlur();
  };

  return (
    <div className="stage-filter-value-wrapper date-filter-wrapper" ref={dropdownRef}>
      <Button
        event={onOpen}
        backgroundColor="var(--body__background, #ffffff)"
        color="var(--header__color)"
        border="1px solid var(--border__color)"
        style={{
          width: "100%",
          justifyContent: "space-between",
          padding: "8px 12px",
          fontFamily: "inherit",
          fontSize: "14px",
        }}
        hoverStyles={{
          borderColor: "#6860ee",
        }}
        hoverd={true}
        aria-label={`Select date`}
        aria-expanded={isOpen}
      >
        <span
          style={{
            flex: 1,
            textAlign: "left",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {value ? (
            value
          ) : (
            <span style={{ color: "#9AA0A6" }}>Select date</span>
          )}
        </span>
        <span
          style={{ fontSize: "10px", marginLeft: "8px", flexShrink: 0 }}
        >
          ▼
        </span>
      </Button>
      {isOpen && (
        <div className="stage-list-dropdown">
          {dateOptions.map((dateOption) => {
            const isSelected = value === dateOption;
            return (
              <div
                key={dateOption}
                role="option"
                tabIndex={0}
                className={`stage-list-dropdown-item ${
                  isSelected ? "stage-list-dropdown-item--selected" : ""
                }`}
                onClick={() => handleSelect(dateOption)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleSelect(dateOption);
                  }
                }}
                aria-selected={isSelected}
              >
                <span className="stage-label">{dateOption}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

DateFilter.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};

export default DateFilter;